<div class="modal-header">
    <h5 class="modal-title"><i [ngClass]="titleIconClass" *ngIf="titleIconClass"></i> {{title}}</h5>
    <div class="d-flex gap-1">
        @if (modalCtrl.opts.fullscreen) {
        <button type="button" class="btn btn-light btn-sm" (click)="modalCtrl.toggleFullscreen()">
            <i
                [ngClass]="this.modalCtrl.state.fullscreen ? 'fa-regular fa-window-minimize' : 'fa-regular fa-window-maximize'"></i>
        </button>
        }
        @if (modalCtrl.opts.drag) {
        <button type="button" class="btn btn-light btn-sm" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle
            [disabled]="modalCtrl.state.fullscreen">
            <i class="fa-solid fa-arrows-up-down-left-right"></i>
        </button>
        }
        <button type="button" class="btn btn-light btn-sm" (click)="modalCtrl.activeModal.dismiss()">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
</div>
<div class="modal-body pt-2">
    <div class="d-flex flex-column np-flex-h100">
        <div class="d-flex gap-1 mb-1">
            <div class="d-inline-flex gap-1 my-1">
                <label><input type="radio" class="form-check-input" value="" [(ngModel)]="filterOpts.params.success"
                        (change)="filterOpts.doFilter()">
                    전체</label>
                <label><input type="radio" class="form-check-input" [value]="true"
                        [(ngModel)]="filterOpts.params.success" (change)="filterOpts.doFilter()">
                    성공</label>
                <label class="form-check-label"><input type="radio" class="form-check-input" [value]="false"
                        [(ngModel)]="filterOpts.params.success" (change)="filterOpts.doFilter()">
                    실패</label>
            </div>
            <div class="ms-auto">
                <wj-flex-grid-search [placeholder]="'키워드 (AND 검색)'" [grid]="flexGrid1"></wj-flex-grid-search>
            </div>
        </div>
        <div class="np-flex-grid-theme-3 d-flex flex-column np-flex-h100">
            <wj-flex-grid #flexGrid1 (initialized)="flexGrid1Ctrl.init(flexGrid1)" [itemsSource]="flexGrid1Cv"
                [isReadOnly]="true" [frozenColumns]="2" [style.height]="modalCtrl.state.fullscreen ? '100vh' : '500px'">

                <ng-template wjFlexGridCellTemplate [cellTypeStr]="'RowHeader'" let-row="row">
                    {{row.index + 1}}
                </ng-template>

                <wj-flex-grid-column [header]="'성공'" [binding]="'success'" [width]="50">
                    <ng-template wjFlexGridCellTemplate [cellTypeStr]="'Cell'" let-cell="cell" let-item="item">
                        @if (item.success == true) {
                        <p class="text-success mb-0">성공</p>
                        } @else {
                        <p class="text-danger mb-0">실패</p>
                        }
                    </ng-template>
                </wj-flex-grid-column>

                @for(header of headers;track $index) {
                <wj-flex-grid-column [header]="header.name" [binding]="header.binding" [width]="header.width"
                    [align]="header.align" [isReadOnly]="true">
                </wj-flex-grid-column>
                }

            </wj-flex-grid>
        </div>
    </div>

</div>